// Получение дней для отображения календаря
export const getDates = date => {
    const monthsNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

    let result = {
        // Массив для дней
        days: [],
        today: new Date().toLocaleDateString('fr-CA'),
        prev: '',
        next: '',
        monthYear: '',
    };
    // Объект даты
    let dateObj = new Date(date);
    // Текущий год
    let year = dateObj.getFullYear();
    // Текущий месяц
    let month = dateObj.getMonth();
    // Количество дней в месяце
    let monthDays = new Date(year, month + 1, 0).getDate();
    // Первый день текущего месяца
    let firstDay = new Date(year, month, 1);
    // Номер первого дня месяца
    let firstDayNum = firstDay.getDay();
    if (firstDayNum === 0) {
        firstDayNum = 7;
    }

    // Предыдущий и следующий месяц
    result.prev = new Date(firstDay.setMonth(firstDay.getMonth() - 1)).toLocaleDateString('fr-CA');
    result.next = new Date(firstDay.setMonth(firstDay.getMonth() + 2)).toLocaleDateString('fr-CA');

    // Название месяца и год
    result.monthYear = monthsNames[month] + ' ' + year;

    // Добавляем пропуски перед первым днём месяца
    for (let i = 0; i < firstDayNum - 1; i++) {
        result.days.push({
            day: '',
            date: ''
        });
    }

    // Добавляем дни месяца
    for (let i = 1; i < monthDays + 1; i++) {
        // Добавляем «0» к месяцу, если нужно
        let m = month + 1 < 10 ? '0' + (month + 1) : month + 1;
        // Добавляем «0» к дню, если нужно
        let d = i < 10 ? '0' + i : i;
        result.days.push({
            day: i,
            date: `${ year }-${ m }-${ d }`
        });
    }

    return result;
};